import {Container, ContainerProps} from "@mantine/core";
import {InsightContainer, InsightContainerProps} from "../InsightContainer/InsightContainer";
import {PropsWithChildren} from "react";

export type InsightChartContainerProps = Omit<InsightContainerProps, 'children'> & {
  containerProps?: ContainerProps
}

export const InsightChartContainer = (props: PropsWithChildren<InsightChartContainerProps>) => {
  const {
    containerProps,
    children,
    ...rest
  } = props

  return (
    <InsightContainer {...rest}>
      <Container {...containerProps}>
        {children}
      </Container>
    </InsightContainer>
  );
}

